/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowchange2Inputs */

const en_aiflowchange2 = /** @type {(inputs: Aiflowchange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change`)
};

const de_aiflowchange2 = /** @type {(inputs: Aiflowchange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändern`)
};

/**
* | output |
* | --- |
* | "Change" |
*
* @param {Aiflowchange2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowchange2 = /** @type {((inputs?: Aiflowchange2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowchange2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowchange2(inputs)
	return de_aiflowchange2(inputs)
});
export { aiflowchange2 as "aiFlowChange" }